/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/issue.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { IssueServiceCreateAttachmentBody } from '../models'
// @ts-ignore
import type { IssueServiceCreateCommentBody } from '../models'
// @ts-ignore
import type { IssueServiceCreateIssueLinkBody } from '../models'
// @ts-ignore
import type { IssueServiceMoveIssueBody } from '../models'
// @ts-ignore
import type { IssueServiceSetIssueLabelsBody } from '../models'
// @ts-ignore
import type { IssueServiceSetIssueWatcherBody } from '../models'
// @ts-ignore
import type { IssueServiceUpdateCommentBody } from '../models'
// @ts-ignore
import type { IssueServiceUpdateIssueBody } from '../models'
// @ts-ignore
import type { RpcStatus } from '../models'
// @ts-ignore
import type { TrackerAttachmentResponse } from '../models'
// @ts-ignore
import type { TrackerCommentResponse } from '../models'
// @ts-ignore
import type { TrackerCreateIssueRequest } from '../models'
// @ts-ignore
import type { TrackerCreateIssuesBatchRequest } from '../models'
// @ts-ignore
import type { TrackerCreateIssuesBatchResponse } from '../models'
// @ts-ignore
import type { TrackerGetBoardResponse } from '../models'
// @ts-ignore
import type { TrackerGetIssuesByKeysResponse } from '../models'
// @ts-ignore
import type { TrackerIssueLinkResponse } from '../models'
// @ts-ignore
import type { TrackerIssueResponse } from '../models'
// @ts-ignore
import type { TrackerListAttachmentsResponse } from '../models'
// @ts-ignore
import type { TrackerListColumnIssuesResponse } from '../models'
// @ts-ignore
import type { TrackerListCommentsResponse } from '../models'
// @ts-ignore
import type { TrackerListIssueHistoryResponse } from '../models'
// @ts-ignore
import type { TrackerListIssueLinksResponse } from '../models'
// @ts-ignore
import type { TrackerListIssuesResponse } from '../models'
// @ts-ignore
import type { TrackerMoveIssueResponse } from '../models'
// @ts-ignore
import type { TrackerSearchIssuesResponse } from '../models'
/**
 * IssueServiceApi - axios parameter creator
 */
export const IssueServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Attaches a file that has already been uploaded to files-service.
     * @param {string} issueId
     * @param {IssueServiceCreateAttachmentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateAttachment: async (
      issueId: string,
      body: IssueServiceCreateAttachmentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceCreateAttachment', 'issueId', issueId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceCreateAttachment', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/attachments`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a comment. People mentioned in it are named in the request — the service does not parse markdown to find them.
     * @param {string} issueId
     * @param {IssueServiceCreateCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateComment: async (
      issueId: string,
      body: IssueServiceCreateCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceCreateComment', 'issueId', issueId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceCreateComment', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/comments`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a task. Its number continues the project counter, and its key is the project prefix plus that number.
     * @param {TrackerCreateIssueRequest} body A new task.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateIssue: async (
      body: TrackerCreateIssueRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceCreateIssue', 'body', body)
      const localVarPath = `/api/v1/tracker/issues`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Links two tasks.
     * @param {string} sourceIssueId
     * @param {IssueServiceCreateIssueLinkBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateIssueLink: async (
      sourceIssueId: string,
      body: IssueServiceCreateIssueLinkBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sourceIssueId' is not null or undefined
      assertParamExists('issueServiceCreateIssueLink', 'sourceIssueId', sourceIssueId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceCreateIssueLink', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/{sourceIssueId}/links`.replace(
        '{sourceIssueId}',
        encodeURIComponent(String(sourceIssueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates several tasks at once, in one transaction: either all of them appear under the given epic, or none does. Meant for an agent decomposing an epic — a half-written batch is worse than no batch.
     * @param {TrackerCreateIssuesBatchRequest} body A batch of tasks to create under one epic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateIssuesBatch: async (
      body: TrackerCreateIssuesBatchRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceCreateIssuesBatch', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/batch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Detaches a file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteAttachment: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceDeleteAttachment', 'id', id)
      const localVarPath = `/api/v1/tracker/attachments/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteComment: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceDeleteComment', 'id', id)
      const localVarPath = `/api/v1/tracker/comments/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a task.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteIssue: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceDeleteIssue', 'id', id)
      const localVarPath = `/api/v1/tracker/issues/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes a link.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteIssueLink: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceDeleteIssueLink', 'id', id)
      const localVarPath = `/api/v1/tracker/links/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the board: every column with the first page of its cards. Long columns are cut to the limit and report their true size.
     * @param {string} projectId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceGetBoardFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceGetBoardFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {number} [issuesPerColumn] How many cards to return per column. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceGetBoard: async (
      projectId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceGetBoardFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceGetBoardFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      issuesPerColumn?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('issueServiceGetBoard', 'projectId', projectId)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/board`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (filterAssigneeIds) {
        localVarQueryParameter['filter.assigneeIds'] = filterAssigneeIds
      }

      if (filterLabelIds) {
        localVarQueryParameter['filter.labelIds'] = filterLabelIds
      }

      if (filterTypes) {
        localVarQueryParameter['filter.types'] = filterTypes
      }

      if (filterPriorities) {
        localVarQueryParameter['filter.priorities'] = filterPriorities
      }

      if (filterColumnIds) {
        localVarQueryParameter['filter.columnIds'] = filterColumnIds
      }

      if (filterSearch !== undefined) {
        localVarQueryParameter['filter.search'] = filterSearch
      }

      if (filterParentId !== undefined) {
        localVarQueryParameter['filter.parentId'] = filterParentId
      }

      if (filterOnlyOpen !== undefined) {
        localVarQueryParameter['filter.onlyOpen'] = filterOnlyOpen
      }

      if (filterDueBefore !== undefined) {
        localVarQueryParameter['filter.dueBefore'] =
          (filterDueBefore as any) instanceof Date
            ? (filterDueBefore as any).toISOString()
            : filterDueBefore
      }

      if (issuesPerColumn !== undefined) {
        localVarQueryParameter['issuesPerColumn'] = issuesPerColumn
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one task with its labels, watchers and counts.
     * @param {string} id Identifier or key: DEV-1385 works as well as the uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceGetIssue: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceGetIssue', 'id', id)
      const localVarPath = `/api/v1/tracker/issues/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Exists for automation: the release changelog and the feature-flag cleanup both start from a list of keys scraped out of commits, and asking for them one by one would mean hundreds of round trips per pipeline.
     * @summary Looks up tasks by their keys at once — DEV-1385, DEV-1407 and so on.
     * @param {Array<string>} [keys] Keys such as DEV-1385. Unknown keys are simply absent from the answer: a commit may mention a task from a project the caller cannot see, and that is not a reason to fail the whole request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceGetIssuesByKeys: async (
      keys?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/issues:by-keys`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (keys) {
        localVarQueryParameter['keys'] = keys
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the files attached to a task, with download links.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListAttachments: async (
      issueId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceListAttachments', 'issueId', issueId)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/attachments`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the rest of one column, for boards where a column outgrows the first page.
     * @param {string} columnId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceListColumnIssuesFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListColumnIssues: async (
      columnId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceListColumnIssuesFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'columnId' is not null or undefined
      assertParamExists('issueServiceListColumnIssues', 'columnId', columnId)
      const localVarPath = `/api/v1/tracker/columns/{columnId}/issues`.replace(
        '{columnId}',
        encodeURIComponent(String(columnId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (filterAssigneeIds) {
        localVarQueryParameter['filter.assigneeIds'] = filterAssigneeIds
      }

      if (filterLabelIds) {
        localVarQueryParameter['filter.labelIds'] = filterLabelIds
      }

      if (filterTypes) {
        localVarQueryParameter['filter.types'] = filterTypes
      }

      if (filterPriorities) {
        localVarQueryParameter['filter.priorities'] = filterPriorities
      }

      if (filterColumnIds) {
        localVarQueryParameter['filter.columnIds'] = filterColumnIds
      }

      if (filterSearch !== undefined) {
        localVarQueryParameter['filter.search'] = filterSearch
      }

      if (filterParentId !== undefined) {
        localVarQueryParameter['filter.parentId'] = filterParentId
      }

      if (filterOnlyOpen !== undefined) {
        localVarQueryParameter['filter.onlyOpen'] = filterOnlyOpen
      }

      if (filterDueBefore !== undefined) {
        localVarQueryParameter['filter.dueBefore'] =
          (filterDueBefore as any) instanceof Date
            ? (filterDueBefore as any).toISOString()
            : filterDueBefore
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Comments on a task, oldest first.
     * @param {string} issueId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListComments: async (
      issueId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceListComments', 'issueId', issueId)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/comments`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary The history of a task, newest first.
     * @param {string} issueId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListIssueHistory: async (
      issueId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceListIssueHistory', 'issueId', issueId)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/history`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the links of a task, both directions.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListIssueLinks: async (
      issueId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceListIssueLinks', 'issueId', issueId)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/links`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists tasks of a project with filters and paging — the list view.
     * @param {string} projectId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceListIssuesFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceListIssuesFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {string} [sortBy] Field to sort by: created_at, updated_at, priority, due_date, key.
     * @param {boolean} [sortDesc]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListIssues: async (
      projectId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceListIssuesFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceListIssuesFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      sortBy?: string,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('issueServiceListIssues', 'projectId', projectId)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/issues`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (filterAssigneeIds) {
        localVarQueryParameter['filter.assigneeIds'] = filterAssigneeIds
      }

      if (filterLabelIds) {
        localVarQueryParameter['filter.labelIds'] = filterLabelIds
      }

      if (filterTypes) {
        localVarQueryParameter['filter.types'] = filterTypes
      }

      if (filterPriorities) {
        localVarQueryParameter['filter.priorities'] = filterPriorities
      }

      if (filterColumnIds) {
        localVarQueryParameter['filter.columnIds'] = filterColumnIds
      }

      if (filterSearch !== undefined) {
        localVarQueryParameter['filter.search'] = filterSearch
      }

      if (filterParentId !== undefined) {
        localVarQueryParameter['filter.parentId'] = filterParentId
      }

      if (filterOnlyOpen !== undefined) {
        localVarQueryParameter['filter.onlyOpen'] = filterOnlyOpen
      }

      if (filterDueBefore !== undefined) {
        localVarQueryParameter['filter.dueBefore'] =
          (filterDueBefore as any) instanceof Date
            ? (filterDueBefore as any).toISOString()
            : filterDueBefore
      }

      if (sortBy !== undefined) {
        localVarQueryParameter['sortBy'] = sortBy
      }

      if (sortDesc !== undefined) {
        localVarQueryParameter['sortDesc'] = sortDesc
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Tasks assigned to the calling user, or watched by them, across projects.
     * @param {boolean} [includeWatched] Include tasks the caller watches but is not assigned.
     * @param {boolean} [onlyOpen] Leave out tasks in done columns.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListMyIssues: async (
      includeWatched?: boolean,
      onlyOpen?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/my-issues`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeWatched !== undefined) {
        localVarQueryParameter['includeWatched'] = includeWatched
      }

      if (onlyOpen !== undefined) {
        localVarQueryParameter['onlyOpen'] = onlyOpen
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Moves a task to a column and a place within it. Answers with the column that received it, so that the board can show a limit that is now exceeded.
     * @param {string} id
     * @param {IssueServiceMoveIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceMoveIssue: async (
      id: string,
      body: IssueServiceMoveIssueBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceMoveIssue', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceMoveIssue', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/{id}/move`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Full-text search over tasks the caller may see.
     * @param {string} [query]
     * @param {string} [projectId] Search inside one project only.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceSearchIssues: async (
      query?: string,
      projectId?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (projectId !== undefined) {
        localVarQueryParameter['projectId'] = projectId
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Sets the labels of a task to exactly the ones given.
     * @param {string} issueId
     * @param {IssueServiceSetIssueLabelsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceSetIssueLabels: async (
      issueId: string,
      body: IssueServiceSetIssueLabelsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceSetIssueLabels', 'issueId', issueId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceSetIssueLabels', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/labels`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Starts or stops watching a task.
     * @param {string} issueId
     * @param {IssueServiceSetIssueWatcherBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceSetIssueWatcher: async (
      issueId: string,
      body: IssueServiceSetIssueWatcherBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('issueServiceSetIssueWatcher', 'issueId', issueId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceSetIssueWatcher', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/watchers`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a comment. Only its author may.
     * @param {string} id
     * @param {IssueServiceUpdateCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceUpdateComment: async (
      id: string,
      body: IssueServiceUpdateCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceUpdateComment', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceUpdateComment', 'body', body)
      const localVarPath = `/api/v1/tracker/comments/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a task. Fields left out keep their current values; every change is written to the history.
     * @param {string} id
     * @param {IssueServiceUpdateIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceUpdateIssue: async (
      id: string,
      body: IssueServiceUpdateIssueBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueServiceUpdateIssue', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('issueServiceUpdateIssue', 'body', body)
      const localVarPath = `/api/v1/tracker/issues/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * IssueServiceApi - functional programming interface
 */
export const IssueServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = IssueServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Attaches a file that has already been uploaded to files-service.
     * @param {string} issueId
     * @param {IssueServiceCreateAttachmentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceCreateAttachment(
      issueId: string,
      body: IssueServiceCreateAttachmentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerAttachmentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceCreateAttachment(
        issueId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceCreateAttachment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a comment. People mentioned in it are named in the request — the service does not parse markdown to find them.
     * @param {string} issueId
     * @param {IssueServiceCreateCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceCreateComment(
      issueId: string,
      body: IssueServiceCreateCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerCommentResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceCreateComment(
        issueId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceCreateComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a task. Its number continues the project counter, and its key is the project prefix plus that number.
     * @param {TrackerCreateIssueRequest} body A new task.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceCreateIssue(
      body: TrackerCreateIssueRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerIssueResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceCreateIssue(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceCreateIssue']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Links two tasks.
     * @param {string} sourceIssueId
     * @param {IssueServiceCreateIssueLinkBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceCreateIssueLink(
      sourceIssueId: string,
      body: IssueServiceCreateIssueLinkBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerIssueLinkResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceCreateIssueLink(
        sourceIssueId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceCreateIssueLink']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates several tasks at once, in one transaction: either all of them appear under the given epic, or none does. Meant for an agent decomposing an epic — a half-written batch is worse than no batch.
     * @param {TrackerCreateIssuesBatchRequest} body A batch of tasks to create under one epic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceCreateIssuesBatch(
      body: TrackerCreateIssuesBatchRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerCreateIssuesBatchResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceCreateIssuesBatch(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceCreateIssuesBatch']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Detaches a file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceDeleteAttachment(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceDeleteAttachment(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceDeleteAttachment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceDeleteComment(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceDeleteComment(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceDeleteComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a task.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceDeleteIssue(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceDeleteIssue(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceDeleteIssue']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes a link.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceDeleteIssueLink(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceDeleteIssueLink(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceDeleteIssueLink']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the board: every column with the first page of its cards. Long columns are cut to the limit and report their true size.
     * @param {string} projectId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceGetBoardFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceGetBoardFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {number} [issuesPerColumn] How many cards to return per column. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceGetBoard(
      projectId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceGetBoardFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceGetBoardFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      issuesPerColumn?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerGetBoardResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceGetBoard(
        projectId,
        filterAssigneeIds,
        filterLabelIds,
        filterTypes,
        filterPriorities,
        filterColumnIds,
        filterSearch,
        filterParentId,
        filterOnlyOpen,
        filterDueBefore,
        issuesPerColumn,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceGetBoard']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one task with its labels, watchers and counts.
     * @param {string} id Identifier or key: DEV-1385 works as well as the uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceGetIssue(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerIssueResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceGetIssue(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceGetIssue']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Exists for automation: the release changelog and the feature-flag cleanup both start from a list of keys scraped out of commits, and asking for them one by one would mean hundreds of round trips per pipeline.
     * @summary Looks up tasks by their keys at once — DEV-1385, DEV-1407 and so on.
     * @param {Array<string>} [keys] Keys such as DEV-1385. Unknown keys are simply absent from the answer: a commit may mention a task from a project the caller cannot see, and that is not a reason to fail the whole request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceGetIssuesByKeys(
      keys?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerGetIssuesByKeysResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceGetIssuesByKeys(
        keys,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceGetIssuesByKeys']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the files attached to a task, with download links.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceListAttachments(
      issueId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListAttachmentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceListAttachments(
        issueId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceListAttachments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the rest of one column, for boards where a column outgrows the first page.
     * @param {string} columnId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceListColumnIssuesFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceListColumnIssues(
      columnId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceListColumnIssuesFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListColumnIssuesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceListColumnIssues(
        columnId,
        filterAssigneeIds,
        filterLabelIds,
        filterTypes,
        filterPriorities,
        filterColumnIds,
        filterSearch,
        filterParentId,
        filterOnlyOpen,
        filterDueBefore,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceListColumnIssues']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Comments on a task, oldest first.
     * @param {string} issueId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceListComments(
      issueId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListCommentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceListComments(
        issueId,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceListComments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary The history of a task, newest first.
     * @param {string} issueId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceListIssueHistory(
      issueId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListIssueHistoryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceListIssueHistory(
        issueId,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceListIssueHistory']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the links of a task, both directions.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceListIssueLinks(
      issueId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListIssueLinksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceListIssueLinks(
        issueId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceListIssueLinks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists tasks of a project with filters and paging — the list view.
     * @param {string} projectId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceListIssuesFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceListIssuesFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {string} [sortBy] Field to sort by: created_at, updated_at, priority, due_date, key.
     * @param {boolean} [sortDesc]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceListIssues(
      projectId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceListIssuesFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceListIssuesFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      sortBy?: string,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListIssuesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceListIssues(
        projectId,
        filterAssigneeIds,
        filterLabelIds,
        filterTypes,
        filterPriorities,
        filterColumnIds,
        filterSearch,
        filterParentId,
        filterOnlyOpen,
        filterDueBefore,
        sortBy,
        sortDesc,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceListIssues']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Tasks assigned to the calling user, or watched by them, across projects.
     * @param {boolean} [includeWatched] Include tasks the caller watches but is not assigned.
     * @param {boolean} [onlyOpen] Leave out tasks in done columns.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceListMyIssues(
      includeWatched?: boolean,
      onlyOpen?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListIssuesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceListMyIssues(
        includeWatched,
        onlyOpen,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceListMyIssues']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Moves a task to a column and a place within it. Answers with the column that received it, so that the board can show a limit that is now exceeded.
     * @param {string} id
     * @param {IssueServiceMoveIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceMoveIssue(
      id: string,
      body: IssueServiceMoveIssueBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerMoveIssueResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceMoveIssue(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceMoveIssue']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Full-text search over tasks the caller may see.
     * @param {string} [query]
     * @param {string} [projectId] Search inside one project only.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceSearchIssues(
      query?: string,
      projectId?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerSearchIssuesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceSearchIssues(
        query,
        projectId,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceSearchIssues']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Sets the labels of a task to exactly the ones given.
     * @param {string} issueId
     * @param {IssueServiceSetIssueLabelsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceSetIssueLabels(
      issueId: string,
      body: IssueServiceSetIssueLabelsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerIssueResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceSetIssueLabels(
        issueId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceSetIssueLabels']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Starts or stops watching a task.
     * @param {string} issueId
     * @param {IssueServiceSetIssueWatcherBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceSetIssueWatcher(
      issueId: string,
      body: IssueServiceSetIssueWatcherBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerIssueResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceSetIssueWatcher(
        issueId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceSetIssueWatcher']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a comment. Only its author may.
     * @param {string} id
     * @param {IssueServiceUpdateCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceUpdateComment(
      id: string,
      body: IssueServiceUpdateCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerCommentResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceUpdateComment(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceUpdateComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a task. Fields left out keep their current values; every change is written to the history.
     * @param {string} id
     * @param {IssueServiceUpdateIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueServiceUpdateIssue(
      id: string,
      body: IssueServiceUpdateIssueBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerIssueResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issueServiceUpdateIssue(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['IssueServiceApi.issueServiceUpdateIssue']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * IssueServiceApi - factory interface
 */
export const IssueServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = IssueServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Attaches a file that has already been uploaded to files-service.
     * @param {string} issueId
     * @param {IssueServiceCreateAttachmentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateAttachment(
      issueId: string,
      body: IssueServiceCreateAttachmentBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerAttachmentResponse> {
      return localVarFp
        .issueServiceCreateAttachment(issueId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a comment. People mentioned in it are named in the request — the service does not parse markdown to find them.
     * @param {string} issueId
     * @param {IssueServiceCreateCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateComment(
      issueId: string,
      body: IssueServiceCreateCommentBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerCommentResponse> {
      return localVarFp
        .issueServiceCreateComment(issueId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a task. Its number continues the project counter, and its key is the project prefix plus that number.
     * @param {TrackerCreateIssueRequest} body A new task.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateIssue(
      body: TrackerCreateIssueRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerIssueResponse> {
      return localVarFp
        .issueServiceCreateIssue(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Links two tasks.
     * @param {string} sourceIssueId
     * @param {IssueServiceCreateIssueLinkBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateIssueLink(
      sourceIssueId: string,
      body: IssueServiceCreateIssueLinkBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerIssueLinkResponse> {
      return localVarFp
        .issueServiceCreateIssueLink(sourceIssueId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates several tasks at once, in one transaction: either all of them appear under the given epic, or none does. Meant for an agent decomposing an epic — a half-written batch is worse than no batch.
     * @param {TrackerCreateIssuesBatchRequest} body A batch of tasks to create under one epic.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceCreateIssuesBatch(
      body: TrackerCreateIssuesBatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerCreateIssuesBatchResponse> {
      return localVarFp
        .issueServiceCreateIssuesBatch(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Detaches a file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteAttachment(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .issueServiceDeleteAttachment(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a comment.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteComment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .issueServiceDeleteComment(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a task.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteIssue(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .issueServiceDeleteIssue(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes a link.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceDeleteIssueLink(id: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
      return localVarFp
        .issueServiceDeleteIssueLink(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the board: every column with the first page of its cards. Long columns are cut to the limit and report their true size.
     * @param {string} projectId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceGetBoardFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceGetBoardFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {number} [issuesPerColumn] How many cards to return per column. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceGetBoard(
      projectId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceGetBoardFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceGetBoardFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      issuesPerColumn?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerGetBoardResponse> {
      return localVarFp
        .issueServiceGetBoard(
          projectId,
          filterAssigneeIds,
          filterLabelIds,
          filterTypes,
          filterPriorities,
          filterColumnIds,
          filterSearch,
          filterParentId,
          filterOnlyOpen,
          filterDueBefore,
          issuesPerColumn,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one task with its labels, watchers and counts.
     * @param {string} id Identifier or key: DEV-1385 works as well as the uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceGetIssue(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerIssueResponse> {
      return localVarFp
        .issueServiceGetIssue(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Exists for automation: the release changelog and the feature-flag cleanup both start from a list of keys scraped out of commits, and asking for them one by one would mean hundreds of round trips per pipeline.
     * @summary Looks up tasks by their keys at once — DEV-1385, DEV-1407 and so on.
     * @param {Array<string>} [keys] Keys such as DEV-1385. Unknown keys are simply absent from the answer: a commit may mention a task from a project the caller cannot see, and that is not a reason to fail the whole request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceGetIssuesByKeys(
      keys?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerGetIssuesByKeysResponse> {
      return localVarFp
        .issueServiceGetIssuesByKeys(keys, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the files attached to a task, with download links.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListAttachments(
      issueId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListAttachmentsResponse> {
      return localVarFp
        .issueServiceListAttachments(issueId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the rest of one column, for boards where a column outgrows the first page.
     * @param {string} columnId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceListColumnIssuesFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListColumnIssues(
      columnId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceListColumnIssuesFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListColumnIssuesResponse> {
      return localVarFp
        .issueServiceListColumnIssues(
          columnId,
          filterAssigneeIds,
          filterLabelIds,
          filterTypes,
          filterPriorities,
          filterColumnIds,
          filterSearch,
          filterParentId,
          filterOnlyOpen,
          filterDueBefore,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Comments on a task, oldest first.
     * @param {string} issueId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListComments(
      issueId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListCommentsResponse> {
      return localVarFp
        .issueServiceListComments(issueId, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary The history of a task, newest first.
     * @param {string} issueId
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListIssueHistory(
      issueId: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListIssueHistoryResponse> {
      return localVarFp
        .issueServiceListIssueHistory(issueId, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the links of a task, both directions.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListIssueLinks(
      issueId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListIssueLinksResponse> {
      return localVarFp
        .issueServiceListIssueLinks(issueId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists tasks of a project with filters and paging — the list view.
     * @param {string} projectId
     * @param {Array<string>} [filterAssigneeIds]
     * @param {Array<string>} [filterLabelIds]
     * @param {Array<IssueServiceListIssuesFilterTypesEnum>} [filterTypes]
     * @param {Array<IssueServiceListIssuesFilterPrioritiesEnum>} [filterPriorities]
     * @param {Array<string>} [filterColumnIds]
     * @param {string} [filterSearch] Full-text query over title and description.
     * @param {string} [filterParentId]
     * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
     * @param {string} [filterDueBefore]
     * @param {string} [sortBy] Field to sort by: created_at, updated_at, priority, due_date, key.
     * @param {boolean} [sortDesc]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListIssues(
      projectId: string,
      filterAssigneeIds?: Array<string>,
      filterLabelIds?: Array<string>,
      filterTypes?: Array<IssueServiceListIssuesFilterTypesEnum>,
      filterPriorities?: Array<IssueServiceListIssuesFilterPrioritiesEnum>,
      filterColumnIds?: Array<string>,
      filterSearch?: string,
      filterParentId?: string,
      filterOnlyOpen?: boolean,
      filterDueBefore?: string,
      sortBy?: string,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListIssuesResponse> {
      return localVarFp
        .issueServiceListIssues(
          projectId,
          filterAssigneeIds,
          filterLabelIds,
          filterTypes,
          filterPriorities,
          filterColumnIds,
          filterSearch,
          filterParentId,
          filterOnlyOpen,
          filterDueBefore,
          sortBy,
          sortDesc,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Tasks assigned to the calling user, or watched by them, across projects.
     * @param {boolean} [includeWatched] Include tasks the caller watches but is not assigned.
     * @param {boolean} [onlyOpen] Leave out tasks in done columns.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceListMyIssues(
      includeWatched?: boolean,
      onlyOpen?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListIssuesResponse> {
      return localVarFp
        .issueServiceListMyIssues(
          includeWatched,
          onlyOpen,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Moves a task to a column and a place within it. Answers with the column that received it, so that the board can show a limit that is now exceeded.
     * @param {string} id
     * @param {IssueServiceMoveIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceMoveIssue(
      id: string,
      body: IssueServiceMoveIssueBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerMoveIssueResponse> {
      return localVarFp
        .issueServiceMoveIssue(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Full-text search over tasks the caller may see.
     * @param {string} [query]
     * @param {string} [projectId] Search inside one project only.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceSearchIssues(
      query?: string,
      projectId?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerSearchIssuesResponse> {
      return localVarFp
        .issueServiceSearchIssues(query, projectId, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Sets the labels of a task to exactly the ones given.
     * @param {string} issueId
     * @param {IssueServiceSetIssueLabelsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceSetIssueLabels(
      issueId: string,
      body: IssueServiceSetIssueLabelsBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerIssueResponse> {
      return localVarFp
        .issueServiceSetIssueLabels(issueId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Starts or stops watching a task.
     * @param {string} issueId
     * @param {IssueServiceSetIssueWatcherBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceSetIssueWatcher(
      issueId: string,
      body: IssueServiceSetIssueWatcherBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerIssueResponse> {
      return localVarFp
        .issueServiceSetIssueWatcher(issueId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a comment. Only its author may.
     * @param {string} id
     * @param {IssueServiceUpdateCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceUpdateComment(
      id: string,
      body: IssueServiceUpdateCommentBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerCommentResponse> {
      return localVarFp
        .issueServiceUpdateComment(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a task. Fields left out keep their current values; every change is written to the history.
     * @param {string} id
     * @param {IssueServiceUpdateIssueBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueServiceUpdateIssue(
      id: string,
      body: IssueServiceUpdateIssueBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerIssueResponse> {
      return localVarFp
        .issueServiceUpdateIssue(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * IssueServiceApi - object-oriented interface
 */
export class IssueServiceApi extends BaseAPI {
  /**
   *
   * @summary Attaches a file that has already been uploaded to files-service.
   * @param {string} issueId
   * @param {IssueServiceCreateAttachmentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceCreateAttachment(
    issueId: string,
    body: IssueServiceCreateAttachmentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceCreateAttachment(issueId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a comment. People mentioned in it are named in the request — the service does not parse markdown to find them.
   * @param {string} issueId
   * @param {IssueServiceCreateCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceCreateComment(
    issueId: string,
    body: IssueServiceCreateCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceCreateComment(issueId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a task. Its number continues the project counter, and its key is the project prefix plus that number.
   * @param {TrackerCreateIssueRequest} body A new task.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceCreateIssue(body: TrackerCreateIssueRequest, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceCreateIssue(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Links two tasks.
   * @param {string} sourceIssueId
   * @param {IssueServiceCreateIssueLinkBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceCreateIssueLink(
    sourceIssueId: string,
    body: IssueServiceCreateIssueLinkBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceCreateIssueLink(sourceIssueId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates several tasks at once, in one transaction: either all of them appear under the given epic, or none does. Meant for an agent decomposing an epic — a half-written batch is worse than no batch.
   * @param {TrackerCreateIssuesBatchRequest} body A batch of tasks to create under one epic.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceCreateIssuesBatch(
    body: TrackerCreateIssuesBatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceCreateIssuesBatch(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Detaches a file.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceDeleteAttachment(id: string, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceDeleteAttachment(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a comment.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceDeleteComment(id: string, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceDeleteComment(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a task.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceDeleteIssue(id: string, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceDeleteIssue(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes a link.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceDeleteIssueLink(id: string, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceDeleteIssueLink(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the board: every column with the first page of its cards. Long columns are cut to the limit and report their true size.
   * @param {string} projectId
   * @param {Array<string>} [filterAssigneeIds]
   * @param {Array<string>} [filterLabelIds]
   * @param {Array<IssueServiceGetBoardFilterTypesEnum>} [filterTypes]
   * @param {Array<IssueServiceGetBoardFilterPrioritiesEnum>} [filterPriorities]
   * @param {Array<string>} [filterColumnIds]
   * @param {string} [filterSearch] Full-text query over title and description.
   * @param {string} [filterParentId]
   * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
   * @param {string} [filterDueBefore]
   * @param {number} [issuesPerColumn] How many cards to return per column. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceGetBoard(
    projectId: string,
    filterAssigneeIds?: Array<string>,
    filterLabelIds?: Array<string>,
    filterTypes?: Array<IssueServiceGetBoardFilterTypesEnum>,
    filterPriorities?: Array<IssueServiceGetBoardFilterPrioritiesEnum>,
    filterColumnIds?: Array<string>,
    filterSearch?: string,
    filterParentId?: string,
    filterOnlyOpen?: boolean,
    filterDueBefore?: string,
    issuesPerColumn?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceGetBoard(
        projectId,
        filterAssigneeIds,
        filterLabelIds,
        filterTypes,
        filterPriorities,
        filterColumnIds,
        filterSearch,
        filterParentId,
        filterOnlyOpen,
        filterDueBefore,
        issuesPerColumn,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one task with its labels, watchers and counts.
   * @param {string} id Identifier or key: DEV-1385 works as well as the uuid.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceGetIssue(id: string, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceGetIssue(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Exists for automation: the release changelog and the feature-flag cleanup both start from a list of keys scraped out of commits, and asking for them one by one would mean hundreds of round trips per pipeline.
   * @summary Looks up tasks by their keys at once — DEV-1385, DEV-1407 and so on.
   * @param {Array<string>} [keys] Keys such as DEV-1385. Unknown keys are simply absent from the answer: a commit may mention a task from a project the caller cannot see, and that is not a reason to fail the whole request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceGetIssuesByKeys(keys?: Array<string>, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceGetIssuesByKeys(keys, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the files attached to a task, with download links.
   * @param {string} issueId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceListAttachments(issueId: string, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceListAttachments(issueId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the rest of one column, for boards where a column outgrows the first page.
   * @param {string} columnId
   * @param {Array<string>} [filterAssigneeIds]
   * @param {Array<string>} [filterLabelIds]
   * @param {Array<IssueServiceListColumnIssuesFilterTypesEnum>} [filterTypes]
   * @param {Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>} [filterPriorities]
   * @param {Array<string>} [filterColumnIds]
   * @param {string} [filterSearch] Full-text query over title and description.
   * @param {string} [filterParentId]
   * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
   * @param {string} [filterDueBefore]
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceListColumnIssues(
    columnId: string,
    filterAssigneeIds?: Array<string>,
    filterLabelIds?: Array<string>,
    filterTypes?: Array<IssueServiceListColumnIssuesFilterTypesEnum>,
    filterPriorities?: Array<IssueServiceListColumnIssuesFilterPrioritiesEnum>,
    filterColumnIds?: Array<string>,
    filterSearch?: string,
    filterParentId?: string,
    filterOnlyOpen?: boolean,
    filterDueBefore?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceListColumnIssues(
        columnId,
        filterAssigneeIds,
        filterLabelIds,
        filterTypes,
        filterPriorities,
        filterColumnIds,
        filterSearch,
        filterParentId,
        filterOnlyOpen,
        filterDueBefore,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Comments on a task, oldest first.
   * @param {string} issueId
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceListComments(
    issueId: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceListComments(issueId, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary The history of a task, newest first.
   * @param {string} issueId
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceListIssueHistory(
    issueId: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceListIssueHistory(issueId, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the links of a task, both directions.
   * @param {string} issueId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceListIssueLinks(issueId: string, options?: RawAxiosRequestConfig) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceListIssueLinks(issueId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists tasks of a project with filters and paging — the list view.
   * @param {string} projectId
   * @param {Array<string>} [filterAssigneeIds]
   * @param {Array<string>} [filterLabelIds]
   * @param {Array<IssueServiceListIssuesFilterTypesEnum>} [filterTypes]
   * @param {Array<IssueServiceListIssuesFilterPrioritiesEnum>} [filterPriorities]
   * @param {Array<string>} [filterColumnIds]
   * @param {string} [filterSearch] Full-text query over title and description.
   * @param {string} [filterParentId]
   * @param {boolean} [filterOnlyOpen] Only tasks that are not in a done column.
   * @param {string} [filterDueBefore]
   * @param {string} [sortBy] Field to sort by: created_at, updated_at, priority, due_date, key.
   * @param {boolean} [sortDesc]
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceListIssues(
    projectId: string,
    filterAssigneeIds?: Array<string>,
    filterLabelIds?: Array<string>,
    filterTypes?: Array<IssueServiceListIssuesFilterTypesEnum>,
    filterPriorities?: Array<IssueServiceListIssuesFilterPrioritiesEnum>,
    filterColumnIds?: Array<string>,
    filterSearch?: string,
    filterParentId?: string,
    filterOnlyOpen?: boolean,
    filterDueBefore?: string,
    sortBy?: string,
    sortDesc?: boolean,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceListIssues(
        projectId,
        filterAssigneeIds,
        filterLabelIds,
        filterTypes,
        filterPriorities,
        filterColumnIds,
        filterSearch,
        filterParentId,
        filterOnlyOpen,
        filterDueBefore,
        sortBy,
        sortDesc,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Tasks assigned to the calling user, or watched by them, across projects.
   * @param {boolean} [includeWatched] Include tasks the caller watches but is not assigned.
   * @param {boolean} [onlyOpen] Leave out tasks in done columns.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceListMyIssues(
    includeWatched?: boolean,
    onlyOpen?: boolean,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceListMyIssues(
        includeWatched,
        onlyOpen,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Moves a task to a column and a place within it. Answers with the column that received it, so that the board can show a limit that is now exceeded.
   * @param {string} id
   * @param {IssueServiceMoveIssueBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceMoveIssue(
    id: string,
    body: IssueServiceMoveIssueBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceMoveIssue(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Full-text search over tasks the caller may see.
   * @param {string} [query]
   * @param {string} [projectId] Search inside one project only.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceSearchIssues(
    query?: string,
    projectId?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceSearchIssues(query, projectId, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Sets the labels of a task to exactly the ones given.
   * @param {string} issueId
   * @param {IssueServiceSetIssueLabelsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceSetIssueLabels(
    issueId: string,
    body: IssueServiceSetIssueLabelsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceSetIssueLabels(issueId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Starts or stops watching a task.
   * @param {string} issueId
   * @param {IssueServiceSetIssueWatcherBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceSetIssueWatcher(
    issueId: string,
    body: IssueServiceSetIssueWatcherBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceSetIssueWatcher(issueId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a comment. Only its author may.
   * @param {string} id
   * @param {IssueServiceUpdateCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceUpdateComment(
    id: string,
    body: IssueServiceUpdateCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceUpdateComment(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a task. Fields left out keep their current values; every change is written to the history.
   * @param {string} id
   * @param {IssueServiceUpdateIssueBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public issueServiceUpdateIssue(
    id: string,
    body: IssueServiceUpdateIssueBody,
    options?: RawAxiosRequestConfig,
  ) {
    return IssueServiceApiFp(this.configuration)
      .issueServiceUpdateIssue(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const IssueServiceGetBoardFilterTypesEnum = {
  IssueTypeInvalid: 'ISSUE_TYPE_INVALID',
  IssueTypeEpic: 'ISSUE_TYPE_EPIC',
  IssueTypeStory: 'ISSUE_TYPE_STORY',
  IssueTypeTask: 'ISSUE_TYPE_TASK',
  IssueTypeBug: 'ISSUE_TYPE_BUG',
  IssueTypeSubtask: 'ISSUE_TYPE_SUBTASK',
} as const
export type IssueServiceGetBoardFilterTypesEnum =
  (typeof IssueServiceGetBoardFilterTypesEnum)[keyof typeof IssueServiceGetBoardFilterTypesEnum]
export const IssueServiceGetBoardFilterPrioritiesEnum = {
  PriorityInvalid: 'PRIORITY_INVALID',
  PriorityLowest: 'PRIORITY_LOWEST',
  PriorityLow: 'PRIORITY_LOW',
  PriorityMedium: 'PRIORITY_MEDIUM',
  PriorityHigh: 'PRIORITY_HIGH',
  PriorityHighest: 'PRIORITY_HIGHEST',
} as const
export type IssueServiceGetBoardFilterPrioritiesEnum =
  (typeof IssueServiceGetBoardFilterPrioritiesEnum)[keyof typeof IssueServiceGetBoardFilterPrioritiesEnum]
export const IssueServiceListColumnIssuesFilterTypesEnum = {
  IssueTypeInvalid: 'ISSUE_TYPE_INVALID',
  IssueTypeEpic: 'ISSUE_TYPE_EPIC',
  IssueTypeStory: 'ISSUE_TYPE_STORY',
  IssueTypeTask: 'ISSUE_TYPE_TASK',
  IssueTypeBug: 'ISSUE_TYPE_BUG',
  IssueTypeSubtask: 'ISSUE_TYPE_SUBTASK',
} as const
export type IssueServiceListColumnIssuesFilterTypesEnum =
  (typeof IssueServiceListColumnIssuesFilterTypesEnum)[keyof typeof IssueServiceListColumnIssuesFilterTypesEnum]
export const IssueServiceListColumnIssuesFilterPrioritiesEnum = {
  PriorityInvalid: 'PRIORITY_INVALID',
  PriorityLowest: 'PRIORITY_LOWEST',
  PriorityLow: 'PRIORITY_LOW',
  PriorityMedium: 'PRIORITY_MEDIUM',
  PriorityHigh: 'PRIORITY_HIGH',
  PriorityHighest: 'PRIORITY_HIGHEST',
} as const
export type IssueServiceListColumnIssuesFilterPrioritiesEnum =
  (typeof IssueServiceListColumnIssuesFilterPrioritiesEnum)[keyof typeof IssueServiceListColumnIssuesFilterPrioritiesEnum]
export const IssueServiceListIssuesFilterTypesEnum = {
  IssueTypeInvalid: 'ISSUE_TYPE_INVALID',
  IssueTypeEpic: 'ISSUE_TYPE_EPIC',
  IssueTypeStory: 'ISSUE_TYPE_STORY',
  IssueTypeTask: 'ISSUE_TYPE_TASK',
  IssueTypeBug: 'ISSUE_TYPE_BUG',
  IssueTypeSubtask: 'ISSUE_TYPE_SUBTASK',
} as const
export type IssueServiceListIssuesFilterTypesEnum =
  (typeof IssueServiceListIssuesFilterTypesEnum)[keyof typeof IssueServiceListIssuesFilterTypesEnum]
export const IssueServiceListIssuesFilterPrioritiesEnum = {
  PriorityInvalid: 'PRIORITY_INVALID',
  PriorityLowest: 'PRIORITY_LOWEST',
  PriorityLow: 'PRIORITY_LOW',
  PriorityMedium: 'PRIORITY_MEDIUM',
  PriorityHigh: 'PRIORITY_HIGH',
  PriorityHighest: 'PRIORITY_HIGHEST',
} as const
export type IssueServiceListIssuesFilterPrioritiesEnum =
  (typeof IssueServiceListIssuesFilterPrioritiesEnum)[keyof typeof IssueServiceListIssuesFilterPrioritiesEnum]
